<template>
	<j-card class="bg5">
		<!-- Header -->
		<div class="flex xs-12 p4 bb1 bc7 mb2 xs-middle">
			<div class="flex xs-6 xs-left xs-middle">
				<!-- Select Box for year -->
				<span class="fs4 c6 mr2 fw4">{{ $t("year") }}</span>
				<j-base-select
					class="xs-6 lg-2 mr4"
					:options="years"
					v-model="selectedYear"
					@input="generateChart"
					size="small"
				></j-base-select>
			</div>
			<div class="flex xs-6 xs-right xs-middle">
				<j-button
					class="fs4 c2 mr2 fw3"
					type="tertiary"
					@click="selectChartType('column')"
					>{{ $t("column") }}</j-button
				>
				<j-button
					class="fs4 c2 mr2 fw3"
					type="tertiary"
					@click="selectChartType('line')"
					>{{ $t("line") }}</j-button
				>
			</div>
		</div>
		<!-- Apex Charts -->
		<apexcharts
			v-if="!isLoading"
			width="100%"
			height="350"
			type="line"
			:options="chartOptions"
			:series="series"
		></apexcharts>
		<!-- Loading -->
		<j-spinner class="p8" v-if="isLoading" />
	</j-card>
</template>

<script>
import api from "../api/"
import VueApexCharts from "vue-apexcharts"
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import JBaseSelect from "@/components/JBaseSelect"
import JSpinner from "@/components/JSpinner"
import dayjs from "dayjs"

export default {
	components: {
		JCard,
		JButton,
		apexcharts: VueApexCharts,
		JBaseSelect,
		JSpinner
	},

	data() {
		return {
			isLoading: false,
			chartOptions: {
				xaxis: {
					categories: []
				}
			},

			series: [
				{
					name: "Clients",
					type: "column",
					data: []
				},
				{
					name: "Policies",
					type: "column",
					data: []
				},
				!["aeg_uat", "aeg", "berkley", "berkley_uat"].includes(
					this.$store.state.tenantId
				) && {
					name: "Quotes",
					type: "column",
					data: []
				}
			],

			months: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],

			selectedYear: dayjs().format("YYYY"), //return current year,

			years: []
		}
	},

	methods: {
		selectChartType(type) {
			this.series.forEach(item => (item.type = type))
		},

		// Count how many of items in array are created in each MONTH of the specified YEAR
		// Payload argument accepts array of dates
		// Returns array with 11 indexes (represents 12 months)
		// EXAMPLE: return = array[ 0, 0, 60, 30, 20, 0, 0, 0, 0, 10, 20, 50 ],
		// EXAMPLE: total count for each month: Jan: 0 , Feb: 0, Mar: 60, Apr: 30, May: 20, Jun: 0, Jul: 0, Aug: 0 ,Sep: 0, Oct: 10, Nov: 20, Dec: 50
		countOccurence(payload, year) {
			// each item (Date) in Payload are mapped to ${month} ${year} Example: 'Mar 2019'
			const createdDate = payload.map(item => {
				return dayjs(item.createdAt).format("MMM YYYY")
			})
			let occurence = []
			// Loop through every month in months array e.g Jan Feb Mar Apr .....
			occurence = this.months.map(month => {
				// and count occurence (How many times it appears in array)
				return createdDate.filter(date => date === `${month} ${year}`).length
			})
			// return Array
			return occurence
		},

		async generateChart() {
			this.isLoading = true
			this.chartOptions.xaxis.categories = this.months
			// Retreive Data
			const res = await api.readOccurences()
			// Map Data
			// Each Series Array index represents a data line ( reference: ApexCharts https://apexcharts.com/docs/vue-charts/# )
			// ApexCharts generates data from Series[].data
			this.series[0].data = this.countOccurence(
				[...res.data.individuals.list, ...res.data.companies.list],
				this.selectedYear
			)
			this.series[1].data = this.countOccurence(
				res.data.policies.list,
				this.selectedYear
			)
			if (
				!["aeg_uat", "aeg", "berkley", "berkley_uat"].includes(
					this.$store.state.tenantId
				)
			)
				this.series[2].data = this.countOccurence(
					res.data.quotes.list,
					this.selectedYear
				)
			this.isLoading = false
		},

		getYears() {
			let date = new Date()
			let years = []
			let year = date.getFullYear()

			for (var i = year; i > year - 5; i--) {
				years.push(i)
			}

			return years.map(year => {
				return { name: year.toString(), value: year.toString() }
			})
		}
	},

	created() {
		this.years = this.getYears()
	},

	mounted() {
		this.generateChart()
	}
}
</script>
